const domain = () => ({
  data: {}
})

const request = () => ({
  isFetching: false,
  hasFetched: false,
  hasFailed: false,
  error: null,
  data: []
})

export { domain as default, request }
